import { useNavigate } from "react-router-dom";
import type { VaultEntry } from "@akhshy/types";
import { EntryKindLabel } from "../atoms/EntryKindLabel.tsx";
import { client } from "../../lib/api.ts";
import { useCount } from "../../lib/counts.ts";

export function VaultItem({ entry }: { entry: VaultEntry }) {
  const navigate = useNavigate();
  const opens = useCount("vault", entry.id);
  const opensNote = opens !== null && (
    <span className="use-count marker">opened {opens}×</span>
  );

  const recordOpen = () => {
    // Fire-and-forget; never block the open on analytics.
    void client.metrics.recordVaultOpened(entry.id).catch(() => {});
  };

  if (entry.kind === "note") {
    return (
      <button
        type="button"
        className="vault-item"
        onClick={() => navigate(`/vault/${entry.slug ?? entry.id}`)}
      >
        <EntryKindLabel kind={entry.kind} />
        <h4 className="filename">{entry.filename ?? entry.title}</h4>
        <p>{entry.description}</p>
        <span className="open-note-hint">Open the note →</span>
        {opensNote}
      </button>
    );
  }
  const cta = entry.kind === "read" ? "Read →" : "Visit →";
  return (
    <article className="vault-item">
      <EntryKindLabel kind={entry.kind} />
      <h4>{entry.title}</h4>
      <p>{entry.description}</p>
      {entry.url && (
        <a href={entry.url} target="_blank" rel="noopener" onClick={recordOpen}>
          {cta}
        </a>
      )}
      {opensNote}
    </article>
  );
}
